<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRelatorios',
    componentOptions: {
        title: 'Vega Admin',
        actions: [
            [
                {
                    name: 'Vega Admin',
                    iconClass: 'lyra-icon lyra-modulo-admin',
                    showView: false,
                    action: 'abrirRelatorios',
                    route: 'adminRelatorios'
                }
            ]
        ]
    },

    methods: {
        abrirRelatorios() {
            if (this.$route.name !== 'adminRelatorios') {
                this.$router.push({ name: 'adminRelatorios' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
